import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {FormControl} from "@angular/forms";

@Component({
    selector: "fhm-subscription-type-select-control",
    templateUrl: "./subscription-type-select-control.component.html",
    styleUrls: ["./subscription-type-select-control.component.scss"],
    standalone: false
})
export class SubscriptionTypeSelectControlComponent implements OnChanges {
    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    @Input() disabled: boolean;
    public options: any[] = [
        {label: "Standard", value: "MONTHLY_AMOUNT"},
        {label: "No Subscription Fee", value: "NO_CHARGE"},
        {label: "Min Sales Per Week", value: "MIN_AMOUNT_SALES"},
        {label: "Fixed Monthly Fee", value: "FIXED_MONTHLY_FEE"}];

    public selectedValue: any;



    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = undefined;
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }

}
